import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { HelmetWrapper, SkipNavLink } from 'sarsaparilla';
import { CurrentUserProps } from '../../props/currentUser';
import { getCurrentUser } from '../../reducers/currentUser';
import AccountInfo from '../AccountInfo/index';

import styles from './Header.scss';

const propTypes = {
  currentUser: CurrentUserProps
};

const defaultProps = {};

export class Header extends PureComponent {
  render() {
    const { currentUser: { apiKey: { writeAccess } } } = this.props;

    return (
      <header role="banner" className={styles['ridb-header']}>
        <SkipNavLink />
        <HelmetWrapper title="RIDB" />
        <div className={styles.logo}>
          <img src={`${process.env.CDN}/graphics/recLogoLight.png`} alt="Recreation.gov logo" />
          <div className="h6">
            RIDB 1.0
          </div>
        </div>
        <div className={`${styles.menuItem}`}>
          <Link activeclassname={styles.active} to="/">Home</Link>
        </div>
        <div className={styles.menuItem}>
          <Link activeclassname={styles.active} to="/docs">API Documentation</Link>
        </div>
        <div className={styles.menuItem}>
          <Link activeclassname={styles.active} to="/download">Data Download</Link>
        </div>
        {writeAccess && (
          <div className={styles.menuItem}>
            <Link activeclassname={styles.active} to="/data-steward">Data Management</Link>
          </div>
        )}
        <div className={styles.menuItem}>
          <AccountInfo />
        </div>
      </header>
    );
  }
}

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  currentUser: getCurrentUser(state)
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Header);
